/**
 * @Author: jsopy
 * @Date: 2025-09-10 15:20:56
 * @LastEditTime: 2025-09-16 09:37:40
 * @FilePath: /actdianyuan/src/router/routerdmmeeting.js
 * @Description:
 * @
 */

const Actdmmeeting = [
  {
    path: "/qd",
    component: (resolve) => require(["@/actscrm/meeting.vue"], resolve),
    children: [
      {
        path: ":id",
        name: "scrmMeetWeiXin2",
        component: (resolve) =>
          require(["@/actdownlandmeeting/index.vue"], resolve),
        meta: {
          title: "电源网微信登录",
        },
      },
      {
        path: "sign/:id/:actid?",
        name: "scrmMeetLogin2",
        component: (resolve) =>
          require(["@/actdownlandmeeting/scrmMeetLogin.vue"], resolve),
        meta: {
          title: "电源网会议签到",
        },
      },
      {
        path: "improve/:id/:actid?",
        name: "scrmMeetImprove2",
        component: (resolve) =>
          require(["@/actdownlandmeeting/scrmMeetImprove.vue"], resolve),
        meta: {
          title: "完善信息",
        },
      },
      {
        path: "success/:id/:actid?",
        name: "scrmMeetSuccess2",
        component: (resolve) =>
          require(["@/actdownlandmeeting/scrmMeetSuccess.vue"], resolve),
        meta: {
          title: "签到成功",
        },
      },
      {
        path: "pager/:id",
        name: "scrmMeetPager2",
        component: (resolve) =>
          require(["@/actdownlandmeeting/scrmMeetPager.vue"], resolve),
        meta: {
          title: "会议问卷",
        },
      },
      {
        path: "exchange/:id",
        name: "scrmMeetAuthen2",
        component: (resolve) =>
          require(["@/actdownlandmeeting/scrmMeetAuthen.vue"], resolve),
        meta: {
          title: "资格验证",
        },
      },
      {
        path: "identif/:id",
        name: "scrmMeetIdentif2",
        component: (resolve) =>
          require(["@/actdownlandmeeting/scrmMeetIdentif.vue"], resolve),
        meta: {
          title: "资格验证",
        },
      },
    ],
  },
];

export default Actdmmeeting;
